import { LogNavigationButtons } from 'src/components'

interface Props {
  route: string
  label: string
}

export const NavigationButton = ({ route, label }: Props) => {
  return <LogNavigationButtons items={[{ label, route }]} />
}
